/* eslint-disable class-methods-use-this */
import AnalyticsHelper from '../../utils/analytics-helper';

export default class IntroView {
    constructor(parent, router) {
        this.router = router;
        this.parent = parent;
        this.el = parent.el.querySelector('.intro-view');
        this.beginCta = this.el.querySelector('#begin-application');
        this.back = this.el.querySelector('.back-link.cta-link--finance');
        this.bind();
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }

    bind() {
        this.beginCta.addEventListener('click', (e) => {
            e.preventDefault();

            this.analyticsPush(e.currentTarget, this.parent.order?.summary?.ids?.modeCode);
            this.router.update('privacy');
        });

        this.back.addEventListener('click', (e) => {
            this.analyticsPush(e.currentTarget, this.parent.order?.summary?.ids?.modeCode);
        });
    }

    analyticsPush(el, model) {
        this.parent.AnalyticsHelper.template(el, { model });
        this.parent.AnalyticsHelper.push(el);
    }
}
